/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import { BehaviorSubject } from "rxjs";

const subject = new BehaviorSubject({ text: {} });

export const eventNotifierService = {
  sortEvent: (message) => subject.next({ text: message }),
  clearMessages: () => subject.next(),
  getMessage: () => subject.asObservable(),
  reSend: () => subject.next(subject.getValue()),
  getMessageValue: () => subject.getValue(),
};
